module.exports = __webpack_public_path__ + "static/gallery9-233afbb3587d6f625baf1554be442c8e.jpg";